import React from 'react'
import { motion } from 'framer-motion'
import Breadcrumbs from './Breadcrumbs'

interface PageHeaderProps {
  title: string
  subtitle?: string
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle }) => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-primary-50 via-white to-accent-50">
      <div className="absolute inset-0 bg-grid-pattern opacity-5" />
      <div className="container-custom py-10 md:py-12">
        <Breadcrumbs />
        <motion.h1
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-3xl md:text-4xl font-bold text-gray-900"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="text-gray-600 mt-3 max-w-3xl"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  )
}

export default PageHeader


